document.addEventListener('DOMContentLoaded', function () {
  const slides = document.querySelectorAll('.extra-carousel-video-autoplay .ct-div-block');

  if (!slides.length) {
    return;
  }

  slides.forEach(function (slide) {
    const video = slide.querySelector('video');
    const img = slide.querySelector('img.ct-image');

    if (video && video.getAttribute('src') === '' && img) {
      img.style.display = 'block';
      video.style.display = 'none';
    }
  });
});
